import {
  CM_CONTRACT_START,
  CM_CONTRACT_END,
  CM_CONTRACT_BY_ID,
  CM_CONTRACT_RESET,
} from '../../actions/ContractManagement/ActionTypes';

const initialState = {
  loading: false,
  contractDataById: {},
};

const ContractManagementReducer = (state = initialState, action) => {
  switch (action.type) {
    case CM_CONTRACT_BY_ID:
      return { ...state, contractDataById: action.data };
    case CM_CONTRACT_START:
      return { ...state, loading: true };
    case CM_CONTRACT_END:
      return { ...state, loading: false };
    case CM_CONTRACT_RESET:
      return initialState;
    default:
      return state;
  }
};

export default ContractManagementReducer;
